import {AbstractItem} from "./abstract-task";
import {FlatpickrFn} from "flatpickr/dist/types/instance";

export class SubTask extends AbstractItem {
  constructor(item: HTMLElement, flatpickr: FlatpickrFn, type: string) {
    super(item, flatpickr, type);
  }

  setDeadlineStatusClass(status: string) {
    if (status === `burn`) {
      this.openElement.classList.remove(`one-task__day--current`);
      this.openElement.classList.add(`one-task__day--burn`);
    } else {
      this.openElement.classList.remove(`one-task__day--burn`);
      this.openElement.classList.add(`one-task__day--current`);
    }
  }
}
